import clsx from 'clsx';
import { ChangeEvent, useState } from 'react';

export type IInputBaseProps = {
  label?: string;
  name?: string;
  placeholder?: string;
  labelAfter?: boolean;
  className?: string;
  autoComplete?: string;
  disabled?: boolean | undefined;
  required?: boolean | undefined;
};

export type IInputNumberProps = IInputBaseProps & {
  type: 'number';
  onChange: (value: number) => void;
  value: number;
};

export type IInputPasswordProps = IInputBaseProps & {
  type: 'password';
  onChange: (value: string) => void;
  value: string;
};

export type IInputEmailProps = IInputBaseProps & {
  type: 'email';
  onChange: (value: string) => void;
  value: string;
};

export type IInputTextProps = IInputBaseProps & {
  type: 'text';
  onChange: (value: string) => void;
  value: string;
};

export type IInputCheckboxProps = IInputBaseProps & {
  type: 'checkbox';
  onChange: (value: boolean) => void;
  value: boolean;
};

export type IInputProps =
  | IInputNumberProps
  | IInputPasswordProps
  | IInputEmailProps
  | IInputTextProps
  | IInputCheckboxProps;

type InputValueType = string | number | boolean;

export const Input = ({
  type,
  onChange,
  value,
  label,
  name,
  placeholder,
  labelAfter,
  className,
  autoComplete,
  disabled,
  required,
}: IInputProps) => {
  const [activeValue, setActiveValue] = useState<InputValueType>(value);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const target = event.target;
    const newValue = target.type === 'checkbox' ? target.checked : target.value;
    setActiveValue(newValue);
    (onChange as (value: typeof activeValue) => void).call(this, newValue);
    //onChange(newValue);
  };

  // make sure to render an empty string if there is no value so we dont
  // switch from controlled to uncontrolled input
  //const sanitizedValue = value === null || value === undefined ? '' : value.toString();
  const labelEl = label && (
    <label className="c-label" htmlFor={name}>
      {label}
    </label>
  );

  return (
    <div className={`c-form-element c-form-element--type-textfield c-form-element--${name}`}>
      {label && !labelAfter && labelEl}
      <input
        className={clsx(
          {
            'c-input': true,
          },
          className,
        )}
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        value={activeValue as string}
        onChange={handleChange}
        autoComplete={autoComplete}
        disabled={disabled}
        required={required}
      />
      {label && labelAfter && labelEl}
    </div>
  );
};

export default Input;
